import get from 'lodash/get';
import flow from 'lodash/flow';
import { getConf } from '@configuratorware/configurator-frontendgui/App/configuration';
import * as configuratorActionTypes from '@configuratorware/configurator-frontendgui/App/Reducers/Configurator/Actions';
import { actionTypes as configurationModeActions } from '@configuratorware/configurator-frontendgui/App/Reducers/ConfigurationMode/Actions';
import { getAvailableLicenses, getConfigurationModes } from '@configuratorware/configurator-frontendgui/App/Reducers/ConfigurationMode/Selectors';
import configurationModeReducer from '@configuratorware/configurator-frontendgui/App/Reducers/ConfigurationMode/Reducer';

const initialState = {
  availableModes: getConfigurationModes(),
  selectedMode: null,
  licenses: [],
};

export default function customConfigurationModeReducer(state = initialState, action = {}) {
  switch (action.type) {
    case configuratorActionTypes.RECEIVE_CONFIGURATION: {
      const nextState = configurationModeReducer(state, action); // call the original reducer to get the state
      const item = get(action, 'data.item', {});

      if (getConfigurationModes(item).designer) {
        // if the designer mode is enabled, set it as the selectedMode
        return {
          ...nextState,
          // selectedMode: 'designer',
        };
      }
      return {
        ...nextState,
        // selectedMode: 'designer',
      };
    }
    case configurationModeActions.SELECT_CONFIGURATION_MODE: {
      const { mode } = action;
      return {
        ...state,
        selectedMode: state.availableModes[mode] ? mode : state.selectedMode,
      };
    }
    default:
      return state;
  }
}
